import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import { Navbar } from '../component/shared/Navbar'
import { Helmet } from 'react-helmet-async'
import { useSearchParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { AccountSummary } from '../component/point/AccountSummary'
import { PurchaseHistoryTable } from '../component/point/PurchaseHistoryTable'
import { useGetTripOrderHistory, useGetTripPoints } from '../api/point'
import { TRIP_POINT_START_DATE, TRIP_POINT_END_DATE } from '../constant/point-system-date'

export const TripAccountSummaryScreen = (props) => {
  const startDate = TRIP_POINT_START_DATE
  const endDate = TRIP_POINT_END_DATE

  const [searchParams] = useSearchParams()

  const idParams = searchParams.get('id')
  const htgParams = searchParams.get('htg')

  const accountRes = useGetTripPoints({
    startDate,
    endDate,
    htgCompany: htgParams,
    companyAccountId: idParams,
  })

  const accountData = accountRes?.data ?? []

  const historyRes = useGetTripOrderHistory({
    startDate,
    endDate,
    htgCompany: htgParams,
    companyAccountId: idParams,
  })

  const historyData = historyRes?.data ?? []

  return (
    <>
      <Helmet titleTemplate='%s | Point System' defaultTitle='Point System'>
        <title>Mobil China Trip</title>
      </Helmet>
      <Navbar />
      <Box
        display='flex'
        justifyContent='space-between'
        flexDirection='row'
        px={{ xs: 3, md: 8 }}
        pt={3}
      >
        <Typography variant='h1'>Account Summary</Typography>

        <Button variant='outlined' component={Link} to='/trip-point'>
          Back
        </Button>
      </Box>
      <Box pt={5} pb={10} px={{ xs: 3, sm: 5, md: 10 }}>
        <AccountSummary accountData={accountData} isLoading={accountRes.isLoading} />
        <PurchaseHistoryTable historyData={historyData} htgCompany={htgParams} showPoint={true} />
      </Box>
    </>
  )
}
